import { BetItem } from '../components/BettingSlipDrawer';
import { TopMatchKombiItem } from '../api/types';
import { customBetLabel } from './customBet';

function fmt(val?: string | null): string {
  if (!val) return '';
  const n = parseFloat(String(val));
  if (isNaN(n) || n <= 1) return '';
  return n.toFixed(2).replace('.', ',');
}

/**
 * Turn a Top MatchKombi card into one provider-priced CustomBet (MK+) slip item
 * (operator "all"). Its id is derived from the combination so re-adding the same
 * card is idempotent; callers still drop any other CustomBet on the same event
 * first, since a provider group is one-per-event.
 */
export function buildMatchKombiBetItem(item: TopMatchKombiItem): BetItem {
  const selections = item.selections ?? [];
  const groupId = `cb-${item.combination_id}`;
  return {
    id: groupId,
    matchId: item.event_id,
    matchName: item.event_name,
    betType: 'home',
    tippLabel: customBetLabel(selections.length),
    odds: fmt(item.combined_odds),
    eventId: item.event_id,
    marketId: selections[0]?.market_id,
    outcomeId: selections[0]?.outcome_id,
    specifiers: selections[0]?.specifiers,
    isCustomBet: true,
    customBetGroupId: groupId,
    customBetSelections: selections.map((s) => ({
      market_id: s.market_id,
      specifiers: s.specifiers,
      outcome_id: s.outcome_id,
      market_name: s.market_name,
      outcome_name: s.outcome_name,
    })),
  };
}
